__turbopack_context__.v({
  "isActive": "NavBurgerMenu-module__FA1jTW__isActive",
  "isActiveSubNav": "NavBurgerMenu-module__FA1jTW__isActiveSubNav",
  "navHrefList": "NavBurgerMenu-module__FA1jTW__navHrefList",
  "navItem": "NavBurgerMenu-module__FA1jTW__navItem",
  "navList": "NavBurgerMenu-module__FA1jTW__navList",
  "navListWrapper": "NavBurgerMenu-module__FA1jTW__navListWrapper",
  "navTitle": "NavBurgerMenu-module__FA1jTW__navTitle",
  "navWrapper": "NavBurgerMenu-module__FA1jTW__navWrapper",
  "screenWrapper": "NavBurgerMenu-module__FA1jTW__screenWrapper",
  "subNavWrapper": "NavBurgerMenu-module__FA1jTW__subNavWrapper",
});
